import { usePbProps } from '@content/helpers/src/context.tsx'
import { CardProps } from '../card/types.ts'
import Card from '../card/Card.tsx'
import { useRef } from 'preact/hooks'
import { selectPromotion } from '@content/helpers/src/gtmEvents.js'
import CarouselWrapper from '@commons/carousel-wrapper/CarouselWrapper.tsx'

const ContentSlider = ({ setSelectedPromotionDetails }) => {
    const { copywriting }: any = usePbProps()
    const { cards }: { cards: CardProps[] } = copywriting

    let videoCount = 0
    let imageCount = 0

    const slidesWithTracking = cards?.map(item => {
        const isVideo = item.video && item.video.url
        const trackingType = isVideo ? 'VIDEO' : 'IMAGE'
        const trackingIndex = isVideo ? ++videoCount : ++imageCount

        return { ...item, trackingType, trackingIndex }
    })

    const btnRef = useRef(null)

    const handleClick = item => {
        const ctaName = `${item.trackingType} - ${item.trackingIndex} - ${item.cta.label}`
        selectPromotion({
            ...item.campaign,
            cta_name: ctaName
        })
    }

    return (
        <CarouselWrapper
            carouselOptions={{
                navPosition: 'top',
                'data-slides': cards.length
            }}
            items={slidesWithTracking.map(item => (
                <Card
                    promotion_details={item.link}
                    image={item.image}
                    link={item.link}
                    cta={item.cta}
                    onClick={() => handleClick(item)}
                    sub_heading={item.sub_heading}
                    heading={item.heading}
                    btnRef={btnRef}
                    campaign={item.campaign}
                    onOpenModal={setSelectedPromotionDetails}
                />
            ))}
        />
    )
}

export default ContentSlider
